import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { GRAPHQL_API_ENDPOINT } from '../constants/constants'

const cache = new InMemoryCache()

const IS_LOCALHOST = window.location.hostname.startsWith('localhost')
const uri = IS_LOCALHOST
  ? 'http://localhost:8080/graphql-backend/api/v1/graphql'
  : GRAPHQL_API_ENDPOINT
const link = new HttpLink({
  uri,
  // Use explicit `window.fetch` so that outgoing requests
  // are captured and deferred until the Service Worker is ready.
  // @ts-ignore
  fetch: (...args) => fetch(...args)
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = JSON.parse(localStorage.getItem('okta-token-storage') || '')
    .idToken.idToken
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache'
  },
  query: {
    fetchPolicy: 'no-cache'
  }
}

// Isolate Apollo client, so it could be reused
// in both application runtime and tests.
export const client = new ApolloClient({
  cache,
  link: authLink.concat(link),
  defaultOptions
})
